import type { TaskWithRawAssignees } from '@/hooks/use-tasks-helpers';

/** sync_state identity for the one unfiltered organisation task list. */
export const TASKS_OFFLINE_SCOPE = 'tasks';
export const TASKS_OFFLINE_VIEW_SIGNATURE = 'tasks:v1';

export function isCachedTaskListAcceptable(tasks: TaskWithRawAssignees[]): boolean {
  return tasks.every((task) => Array.isArray(task._rawAssignees));
}

/** Mirrors the server query's `created_at DESC` ordering, including NULLS FIRST. */
export function compareCachedTasks(
  left: TaskWithRawAssignees,
  right: TaskWithRawAssignees,
): number {
  if (!left.created_at) {
    return right.created_at ? -1 : 0;
  }
  if (!right.created_at) {
    return 1;
  }
  return right.created_at.localeCompare(left.created_at);
}
